module.exports = __webpack_public_path__ + "img/Personalized_customization.24c97286.jpg";